import { render, staticRenderFns } from "./PageDailyGameDetails.vue?vue&type=template&id=012a1230&"
import script from "./PageDailyGameDetails.vue?vue&type=script&lang=js&"
export * from "./PageDailyGameDetails.vue?vue&type=script&lang=js&"
import style0 from "./PageDailyGameDetails.vue?vue&type=style&index=0&id=012a1230&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports